import { Alert, Button } from '@catering/ui';
import type { JSX } from 'react';

import { ApiError } from '../api/client';

interface ListLoadErrorProps {
  /** Title of the generic failure, e.g. "No pudimos cargar los remitos". */
  title: string;
  error: unknown;
  onRetry: () => void;
}

/** Shared list-page failure: a 403 reads as "no access" (retrying cannot help), anything else keeps the retry. */
export function ListLoadError({ title, error, onRetry }: ListLoadErrorProps): JSX.Element {
  if (error instanceof ApiError && error.status === 403) {
    return <Alert tone="warning">No tenés acceso a esta pantalla.</Alert>;
  }

  return (
    <Alert tone="danger" title={title}>
      <div className="flex items-center justify-between gap-4">
        <span>Ocurrió un error al buscar. Intentá de nuevo.</span>
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Reintentar
        </Button>
      </div>
    </Alert>
  );
}
